export default new Intl.NumberFormat("es", {
  style: "currency",
  currency: "EUR",
});
